import { Modal } from "../../../../components/modal.jsx";
import { useSelector } from "react-redux";
import { useState } from "react";
import { Step0 } from "./step0.jsx";
import { Step1 } from "./step1.jsx";
import { Step2 } from "./step2.jsx";
import { Step3 } from "./step3.jsx";
import { Step4 } from "./step4.jsx";

export function OnboardingModal() {
  let session = useSelector((state) => state.session);
  let [step, setStep] = useState(0);
  if (!session?.account || session?.account?.companyName || step == 5)
    return <></>;
  return (
    <Modal>
      {step == 0 && <Step0 setStep={setStep} />}
      {step == 1 && <Step1 setStep={setStep} />}
      {step == 2 && <Step2 setStep={setStep} />}
      {step == 3 && <Step3 setStep={setStep} />}
      {step == 4 && <Step4 setStep={setStep} />}
    </Modal>
  );
}
